import React, { useEffect, useState } from "react";
import $ from 'jquery';
import './App.scss';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { images } from "./imagesToLoad";

import Header from './components/Header';
import Footer from './components/Footer';

import Home from './pages/Home';
import Education from "./pages/Education";
import Contacts from "./pages/Contacts";
import Calendar from "./pages/Calendar";
import News from "./pages/News";
import Accounts from "./pages/Accounts";
import Faq from "./pages/Faq";

function App() {
  const [ isLoading, setIsLoading ] = useState(true);

  const loadImage = (image) => {
    return new Promise((resolve, reject) => {
      const newImage = new Image();
      newImage.src = image;
      newImage.onload = () => {
        resolve(image);
      }
      newImage.onerror = (err) => reject(err);
    });
  };

  useEffect(() => {
    isLoading && $('body').addClass("ovf-hidden");
    Promise
      .all(images.map((image) => loadImage(image)))
      .then(() => setIsLoading(false))
      .catch((err) => {
        console.log("Failed to load images", err)
        setIsLoading(false);
      });
    // eslint-disable-next-line  
  }, []);

  useEffect(() => {
    !isLoading && $('body').removeClass("ovf-hidden");
    !isLoading && $('#loader').addClass("hide");
  }, [isLoading]); 
  return (
  <Router>
      <Header/>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/education" element={<Education/>} />
          <Route path="/contacts" element={<Contacts/>} />
          <Route path="/calendar" element={<Calendar/>} />
          <Route path="/news" element={<News/>} />
          <Route path="/accounts" element={<Accounts/>} />
          <Route path="/faq" element={<Faq/>} />
        </Routes>
      <Footer/>
    </Router>
  );
}

export default App;